/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useLifecycles, useUpdateEffect } from 'react-use';
import AccordionCard from '../../components/AccordionCard';
import SubUserRegisterCard from '../../components/subuser/SubUserRegisterCard';
import {
  searchRobot,
  changeCardItem,
  delNewCard,
  setNewCard,
  saveCardItem,
  initNewCard,
  toggleRobot,
} from '../../modules/subUser';
import Toast from '../../components/Toast';

const SubUserRegisterContainer = () => {
  const dispatch = useDispatch();
  const {
    add: {
      robotList,
      newItems: { list },
      itemError,
      itemPending,
      itemResult,
      itemMessage,
    },
  } = useSelector((state) => state.subuser);
  const [open, setOpen] = useState(false);
  const [doneDisabled, setDoneDisabled] = useState(true);
  const [sendSnack, setSendSnack] = useState(null);

  const onAdd = () => dispatch(setNewCard());

  const onOpen = () => {
    setOpen(true);
    onAdd();
  };

  const onClose = () => {
    dispatch(initNewCard());
    setOpen(false);
  };

  const onComplete = (idx) => {
    dispatch(saveCardItem(list[idx]));
  };

  const onCardCancel = (idx) => {
    dispatch(delNewCard(idx));
  };

  const onInfoChange = (info) => {
    if (info.name === 'serial') {
      dispatch(toggleRobot(info));
    }
    dispatch(changeCardItem(info));
  };

  const onSearch = (id, value) => {
    dispatch(searchRobot({ type: 'add', id, value }));
  };

  useEffect(() => {
    if (
      list.filter(({ name, serial }) => name !== '' && serial !== '').length > 0
    )
      setDoneDisabled(false);
    else setDoneDisabled(true);
  }, [list]);

  useUpdateEffect(() => {
    setSendSnack(itemResult);
  }, [itemResult]);

  useUpdateEffect(() => {
    if (!sendSnack && itemResult) {
      dispatch(initNewCard());
    }
  }, [sendSnack]);

  useLifecycles(onSearch, onClose);

  return (
    <>
      <AccordionCard
        {...{
          title: '사용자 등록',
          done: {
            label: '완료',
            onClick: onComplete,
            disabled: doneDisabled || itemPending || itemResult,
          },
          fold: { label: '접기', onClick: onClose },
          unfold: { label: '등록', onClick: onOpen },
        }}
        open={open}
      >
        <Grid container spacing={1}>
          {list.map((listitem, i) => {
            return (
              <Grid item md={4} sm={12} key={`card_grid_${i}`}>
                <SubUserRegisterCard
                  {...{
                    ...listitem,
                    robotList,
                    bAdd: true,
                    itemError: i in itemError ? itemError[i] : null,
                    index: i,
                    key: `card_${i}`,
                    onSearch,
                    onCancel: () => onCardCancel(i),
                    onComplete: () => onComplete(i),
                    onInfoChange,
                  }}
                />
              </Grid>
            );
          })}
          <Grid item>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onAdd}
              sx={{
                minHeight: '416px',
                height: '100%',
                minWidth: 4,
                padding: 0.5,
              }}
            >
              <AddIcon />
            </Button>
          </Grid>
        </Grid>
      </AccordionCard>
      <Toast
        {...{
          open: !!(sendSnack && itemMessage),
          onClose: () => setSendSnack(false),
          message: itemMessage,
          severity: itemResult ? 'success' : 'error',
        }}
      />
    </>
  );
};

export default SubUserRegisterContainer;
